import axios from 'axios';

const saveDeviceData = (request: { blackbox: string }): Promise<void> =>
  axios.post('/qualification/device_data', request);

export { saveDeviceData };
